import firebase from 'firebase/app'
import 'firebase/remote-config'

const APP_NAME = process.env.VUE_APP_APP_NAME

const MasterFirebase = firebase.initializeApp(
  {
    apiKey: process.env.VUE_APP_MASTER_API_KEY,
    authDomain: process.env.VUE_APP_MASTER_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_MASTER_PROJECT_ID,
    appId: process.env.VUE_APP_MASTER_APP_ID
  },
  'master'
)

/** @type {firebase.remoteConfig.RemoteConfig} */
const RemoteConfig = MasterFirebase.remoteConfig()

// Define the configuration of the remote config
RemoteConfig.defaultConfig = {
  settings: {
    minimumFetchIntervalMillis: 30000 // Fetch the remote config every hour
  }
}

/**
 * Initialize the remote configuration and fetch the latest one
 * @returns {Promise}
 */
async function initialize() {
  await RemoteConfig.fetchAndActivate()
  await RemoteConfig.ensureInitialized()

  console.log(
    'Last remote config sync (' + RemoteConfig.lastFetchStatus + ') : ' +
      new Date(RemoteConfig.fetchTimeMillis).toISOString()
  )
}

/**
 * Get a value from the remote config
 * @param {string} key
 * @return {any}
 */
function getValue(key) {
  const projectKey = `${APP_NAME}_${key}`

  return RemoteConfig.getValue(projectKey).asString()
}

/**
 * Get a boolean from the remote config
 * @param {string} key
 * @returns {boolean}
 */
function getBoolean(key) {
  const value = getValue(key)

  return value === 'true'
}

/**
 * Get a string from the remote config
 * @param {string} key
 * @returns {string}
 */
function getString(key) {
  return getValue(key) || ''
}

/**
 * Get a number from the remote config
 * @param {string} key
 * @returns {Number}
 */
function getNumber(key) {
  const value = getValue(key)

  return Number(value)
}

export default {
  initialize,
  getBoolean,
  getValue,
  getString,
  getNumber
}
